/**
 * @file M11 shopping cart overlay
 *
 * @author michael.schmid@notch-interactive.com
 */

// Imports
import overlay from '../components/overlay';

const instance = {};

let overlayInstance;

/**
 * Initiate the module
 */
instance.init = () => {
    overlayInstance = overlay({
        type: 'shopping-cart'
    });
};

/**
 * Destroy the module
 */
instance.destroy = () => {
    try {
        overlayInstance.destroy();
    } catch (e) {
        console.warn(e);
    }
};

export default instance;
